import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import OrchestrateTheOutcomesImage from './OrchestrateTheOutcomesImage'

const copy = {
  heading: `Orchestrate the outcomes you want`,
  description: `Design multi-step interactions that drive to results with a user-friendly visual builder.`,
}

const OrchestrateTheOutcomes = () => (
  <SectionBase variant="2Col">
    <SectionCopy>
      <CopyTextBase>
        <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
        <CopyText.Description tag="p">{copy.description}</CopyText.Description>
      </CopyTextBase>
    </SectionCopy>
    <SectionContents>
      <OrchestrateTheOutcomesImage />
    </SectionContents>
  </SectionBase>
)

const SectionCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
    justify-self: end;
    align-self: center;
  }
`

const SectionContents = styled(Section.Contents)`
  margin: 0 auto;
  max-width: 399px;
`

export default OrchestrateTheOutcomes
